import React, { useContext, useEffect, useState } from "react";

import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  FormLabel,
  FormControl,
} from "@mui/material";

import { CustomButtonPlusIcon } from "./Common/Design/CustomButtonPlusIcon";
import { Cancel, Save } from "@mui/icons-material";
import api from "../api/axios";
import { PermissionContext, UserContext } from "./Context/Context";

const ObservationsCards = ({
  date,
  title,
  content,
  company,
  caseType,
  created_by,
  created_by_name,
  created_by_surname,
  created_by_object,
  observationId,
  status_name,
  contact_id,
  setChangeRender,
  setFlagToShow,
  transferCase = false,
}) => {
  const { can } = useContext(PermissionContext);
  const { userData } = useContext(UserContext);
  const { user } = userData;

  const Swal = require("sweetalert2");
  const preguntasClave = [
    "Fecha nacimiento(edad):",
    "Estado Civil:",
    "Hijos a su cargo:",
    "Situación Laboral (Funciones que desempeña en su caso):",
    "¿Alguna Invalidez otorgada o en trámite?:",
    "¿Cobra dependencia o alguna otra pensión? (En caso afirmativo indicar el tipo de pensión):",
    "¿Ha presentado recientemente alguna solicitud?",
    "¿Tiene resolución?",
    "¿En qué fecha le fue comunicada?",
    "No aceptado: Autorizo el uso de mi correo electrónico para el envío de información comercial, comunicaciones y noticias.",
    "Aceptado: He leído y acepto el Aviso legal y la Política de Privacidad.",
  ];

  const [openEditObservation, setOpenEditObservation] = React.useState(false);
  const [newObservationEdit, setNewObservationEdit] = React.useState("");

  const handleDeleteObservation = async (observationId) => {
    const formData = new FormData();

    await Swal.fire({
      title: "¡Estás a punto de eliminar esta observación!",
      icon: "warning",
      text: "¿Deseas continuar?",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Continuar",
      denyButtonText: "Volver",
    }).then((result) => {
      if (result.isConfirmed) {
        if (observationId === false) {
          formData.append("contact_id", contact_id);
          formData.append("notas", "");

          var editContact = api
            .post(
              `${process.env.REACT_APP_API_URL}/contacts/delete_note_historical`,
              formData,
            )
            .then((response) => {
              console.log(response);
            });
        } else {
          formData.append("id", observationId);

          var deleteNote = api
            .post(
              `${process.env.REACT_APP_API_URL}/contacts/delete_note_historical`,
              formData,
            )
            .then((response) => {
              console.log(response);
            });
        }

        Swal.fire({
          title: "¡Nota Eliminada!",
          icon: "success",
          showDenyButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Continuar",
        });

        setFlagToShow(false);
        setChangeRender((prev) => !prev);
      }
    });
  };

  const handleEditObservations = async (id) => {
    Swal.fire({
      title: "¿Deseas actualizar la nota?",
      text: "Se guardarán los cambios realizados.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "swal-front",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("id", id);
        formData.append("notas", newObservationEdit);

        try {
          // Mostrar loading
          Swal.fire({
            title: "Guardando...",
            text: "Por favor espera un momento",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          const response = await api.post(
            `${process.env.REACT_APP_API_URL}/contacts/update_note_historical`,
            formData,
          );

          // Si la respuesta fue OK
          Swal.fire({
            icon: "success",
            title: "¡Observación actualizada!",
            text: "Los cambios se guardaron correctamente.",
            confirmButtonColor: "#1ab394",
          });

          // Aquí cierras el modal y refrescas
          handleCloseEditObservation();
          setChangeRender((prev) => !prev);
        } catch (error) {
          console.error(error);

          Swal.fire({
            icon: "error",
            title: "Error al guardar",
            text:
              error.response?.data?.message ||
              "Algo salió mal. Intenta de nuevo.",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  };

  const handleClickOpenEditObservation = (id) => {
    setNewObservationEdit(content); // inicializa el textarea con el texto actual
    setOpenEditObservation(true);
  };

  const handleCloseEditObservation = () => {
    setOpenEditObservation(false);
    setNewObservationEdit("");
  };

  const contienePreguntasClave = (texto = "") =>
    preguntasClave.some((pregunta) => texto.includes(pregunta));

  const normalizeTextForTextarea = (htmlText = "") =>
    htmlText.replace(/<br\s*\/?>/gi, "\n");

  const canDeleteNotes =
    // requisito base
    (can("contacts", "deletenotes") || can("clients", "deletenotes")) &&
    // all → puede borrar todas
    (can("contacts", "notes_all") ||
      can("clients", "notes_all") ||
      // own → solo las propias
      ((can("contacts", "notes_own") || can("clients", "notes_own")) &&
        user?.id == created_by_object?.id));

  // console.log(can("contacts", "deletenotes") || can("clients", "deletenotes"));
  return (
    <Card
      sx={{
        marginBottom: "10px",
        border: "1px solid rgb(167 229 255)",
        borderRadius: "4px",
      }}>
      <CardContent sx={{ backgroundColor: "#cfe2f373" }}>
        <div
          style={{
            fontSize: 13,
            display: "flex",
            justifyContent: "space-between",
          }}>
          <b style={{ textAlign: "left" }}>{caseType}</b>
          <b>{date}</b>
        </div>
        <hr></hr>
        <div
          style={{
            justifyContent: "right",
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
          }}>
          <b>Estado de contacto:</b>
          <Typography
            variant="body2"
            sx={{
              width: "120px", // Ajusta el ancho al contenido
              marginLeft: "10px",
              padding: "3px 15px",
              textAlign: "center",
              ...(status_name === "Pte Llamada" ||
                (!status_name && {
                  border: "1px solid #f8ac59",
                  backgroundColor: "#f8ac59",
                  color: "white",
                })),
              ...(status_name === "Cancelado" && {
                border: "1px solid #ed5565",
                backgroundColor: "#ed5565",
                color: "white",
              }),
              ...(status_name === "Llamado" && {
                border: "1px solid #23c6c8",
                backgroundColor: "#23c6c8",
                color: "white",
              }),
              ...(status_name === "Cliente" && {
                border: "1px solid #1ab394",
                backgroundColor: "#1ab394",
                color: "white",
              }),
            }}>
            {status_name || "Sin estado"}
          </Typography>
        </div>
        {company ? (
          <div
            style={{
              justifyContent: "right",
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}>
            <b>Empresa:</b>
            <Typography
              variant="body2"
              sx={{
                marginLeft: "10px",
                padding: "3px 15px",
                width: "120px", // Ajusta el ancho al contenido
                border: "1px dashed",
              }}>
              {company}
            </Typography>
          </div>
        ) : null}
        <Typography
          variant="span"
          component="div"
          sx={{ textAlign: "left", padding: "10px 0px" }}>
          <b>{title.toUpperCase()}</b>
        </Typography>
        <Typography variant="body2" sx={{ textAlign: "left" }}>
          {(() => {
            const processedContent = content?.replace(/\n/g, "<br />");

            return (
              <span dangerouslySetInnerHTML={{ __html: processedContent }} />
            );
          })()}
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "8px 16px",
        }}>
        <Typography sx={{ textAlign: "left", fontSize: "12px" }}>
          Creado por: {created_by_name} {created_by_surname}
        </Typography>

        {contact_id && (
          <Box sx={{ display: "flex", gap: 1 }}>
            {(contienePreguntasClave(content) ||
              ["PRIMERA NOTA", "REGISTRO INICIAL"].includes(
                title?.toUpperCase(),
              )) && (
              <Button
                size="small"
                color="info"
                variant="outlined"
                onClick={() =>
                  handleClickOpenEditObservation(
                    observationId ? observationId : false,
                  )
                }>
                Editar
              </Button>
            )}
            {canDeleteNotes && (
              <Button
                size="small"
                color="error"
                variant="outlined"
                disabled={transferCase}
                onClick={() =>
                  handleDeleteObservation(observationId ? observationId : false)
                }>
                Eliminar
              </Button>
            )}
          </Box>
        )}
      </CardActions>

      {(contienePreguntasClave(content) ||
        ["PRIMERA NOTA", "REGISTRO INICIAL"].includes(
          title?.toUpperCase(),
        )) && (
        <div>
          <Dialog
            open={openEditObservation}
            onClose={handleCloseEditObservation}
            aria-labelledby="custom-dialog-title"
            aria-describedby="custom-dialog-description"
            maxWidth="md"
            fullWidth
            sx={{
              "& .MuiPaper-root": {
                minHeight: "300px", // aquí el mínimo alto
                minWidth: "400px", // si también quieres un ancho mínimo
              },
            }}>
            {/* Título */}
            <DialogTitle id="custom-dialog-title">
              {"Editar observación"}
            </DialogTitle>

            {/* Contenido */}
            <DialogContent style={{ paddingTop: "20px" }}>
              <FormControl style={{ width: "100%" }}>
                <FormLabel sx={{ textAlign: "left" }}>Observación</FormLabel>
                <textarea
                  style={{
                    height: "400px",
                    resize: "none",
                    padding: "10px 15px",
                    fontSize: "15px",
                    borderRadius: "4px",
                    border: "1px solid rgba(128, 128, 128, 0.35)",
                    color: "rgb(70 69 69)",
                  }}
                  onChange={(e) => setNewObservationEdit(e.target.value)}
                  value={
                    newObservationEdit
                      ? normalizeTextForTextarea(newObservationEdit)
                      : ""
                  }
                />
              </FormControl>
            </DialogContent>

            {/* Acciones */}
            <DialogActions>
              <CustomButtonPlusIcon
                icon={Cancel}
                text={"Cancelar"}
                size="small"
                position={"start"}
                color={"error"}
                variant="outlined"
                handleFunction={handleCloseEditObservation}
              />
              <CustomButtonPlusIcon
                icon={Save}
                text={"Guardar"}
                size="small"
                position={"start"}
                color={"success"}
                variant="outlined"
                handleFunction={() => handleEditObservations(observationId)}
              />
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Card>
  );
};

export default ObservationsCards;
